module.exports = __webpack_public_path__ + "img/distracted.de95374c.svg";